export default __webpack_public_path__ + "static/media/44-G72018.f0e8b741.jpg";